import i18n from '@sparklayer-io/spark-dash-pages/i18n';

import en from './en';

// `pages` owns the instance. This package only adds its own slices to it, so a dash-only
// feature can move here without either side re-initialising i18next.
i18n.addResourceBundle('en', 'features', en.features, true, false);
i18n.addResourceBundle('en', 'components', en.components, true, false);
